import React from 'react';
import { Shield, AlertTriangle, CheckCircle, Eye } from 'lucide-react';

export const SecuritySection = () => {
  const features = [
    { icon: Shield, title: 'Ranking transparente', color: 'green' },
    { icon: AlertTriangle, title: 'Antifraude', color: 'purple' },
    { icon: CheckCircle, title: 'Pagamentos garantidos', color: 'green' },
    { icon: Eye, title: 'Ambiente monitorado', color: 'purple' }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-[#0A0A0F] relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-64 h-64 bg-green-primary/20 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8">
          <p className="overline mb-2">Confiança</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black font-archive text-white mb-2">
            Segurança e Transparência
          </h2>
          <p className="text-sm text-gray-400">Competição justa. Sistema seguro.</p>
        </div>

        {/* Mobile: Compact 2x2 Grid */}
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 lg:gap-6 mb-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            const isGreen = feature.color === 'green';
            
            return (
              <div
                key={index}
                className={`game-card p-4 sm:p-5 rounded-xl text-center ${
                  isGreen ? 'border-green-primary/30' : 'border-purple-primary/30'
                }`}
              >
                {/* Icon */}
                <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center mx-auto mb-3 ${
                  isGreen 
                    ? 'bg-gradient-to-br from-green-primary to-green-secondary' 
                    : 'bg-gradient-to-br from-purple-primary to-purple-light'
                }`}>
                  <Icon className="text-white" size={24} />
                </div>
                
                <h3 className={`text-xs sm:text-sm font-bold ${
                  isGreen ? 'text-green-primary' : 'text-purple-light'
                }`}>
                  {feature.title}
                </h3>
              </div>
            );
          })}
        </div>

        {/* Trust Badge */}
        <div className="text-center">
          <div className="inline-flex items-center gap-2 bg-black/40 backdrop-blur border border-green-primary/30 rounded-full px-5 py-2.5">
            <Shield className="text-green-primary" size={18} />
            <span className="text-xs sm:text-sm text-gray-300 font-medium">
              Plataforma certificada e 100% segura
            </span>
            <CheckCircle className="text-green-primary" size={16} />
          </div>
        </div>
      </div>
    </section>
  );
};
